import React, { useContext } from 'react';
import Button from 'components/atoms/Button';
import AddEditLevers from 'components/molecules/PromoRecommendation/AddEditLevers';
import AddEditSpends from 'components/molecules/PromoRecommendation/AddEditSpends';
import { CustomModal } from 'CustomComponentCss';
import { promoRecommendation } from 'contexts/PromoRecommendationContext';
import useUpdatePlan from 'hooks/promoRecommendation/useUpdatePlan';
import { FilterContextData } from 'contexts/FilterContext';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin, notification } from 'antd';
import _ from 'lodash';
import { trackEventMixpanel } from 'utils/mixpanel';
import {
    PROMO_RECOMMENDATION_ADD_EVENT_APPLY_CLICKED,
    PROMO_RECOMMENDATION_ADD_EVENT_RESET_CLICKED,
    PROMO_RECOMMENDATION_EDIT_EVENT_APPLY_CLICKED,
} from 'utils/mixpanelEventNames';

interface props {
    addEditModal: boolean;
    setAddEditModal: Function;
    PromotionMechanicValueData: '';
}
export function formatDim1_data(SelectedLowerLevel: any) {
    let dim1_data: any = {};
    Object.keys(SelectedLowerLevel).forEach((key: string) => {
        let dim1Data = SelectedLowerLevel[key];
        dim1_data[dim1Data.dim1Id] = {
            open_stock: dim1Data.openStock,
            shipper_stock: dim1Data.shipperStock,
        };
    });
    return dim1_data;
}

//add spend transform ui object to query object
export function formatAddSpends(spendType: any, addSpend: any) {
    let spends_data: any = {};
    spendType?.forEach((data: any) => {
        if (data === 'per_qty') {
            spends_data[data] = addSpend['per_qty'].spends;
            spends_data['redemption'] = addSpend['per_qty'].redemption;
        } else {
            spends_data[data] = addSpend[data];
        }
    });
    return spends_data;
}

const AddEditEventModal: React.FC<props> = ({ addEditModal, setAddEditModal, PromotionMechanicValueData }) => {
    const {
        selectedPlan,
        addLeverData,
        addSpends,
        editMode,
        setAddLeverData,
        setSpendType,
        setEditMode,
        spendType,
        setAddSpends,
        setTempRange,
        setStateForCalender,
        resetAllStateForAdd,
        fetchEventsList,
        eventsDataFormat,
        editRowData,
        eventDataFromOriginalData,
    } = useContext(promoRecommendation);

    const { loading, error, updateEventFunction } = useUpdatePlan(
        fetchEventsList,
        selectedPlan,
        onCompleteUpdateAddEvent,
        true,
    );
    const { appConfig } = useContext(UserContext);
    const { spendLabel, leverKeys, spendTopForm, retailerKey, hideAddSpends } = getConfig(
        'promoRecommendation',
        appConfig,
    );
    const { idForRestOfComponent, allCheckedAttribute, currentFrequency } = useContext(FilterContextData);

    const antIcon = <LoadingOutlined style={{ fontSize: 16, color: 'white' }} spin />;

    const openNotification = (message: string) => {
        notification.open({
            message: message,
            className: 'custom-class',
            style: {
                width: 350,
                height: 70,
            },
        });
    };
    const handleOk = () => {
        setAddEditModal(false);
    };
    const handleCancel = () => {
        setAddEditModal(false);
        setEditMode(false);
        resetAllStateForAdd();
    };

    function onCompleteUpdateAddEvent() {
        setAddEditModal(() => false);
        resetAllStateForAdd();
    }
    //onApply button
    function onApplyButton() {
        //is edit check
        if (!editMode) {
            let event_data: any = {
                spends_data: {},
            };
            //added all keys from add lever except ppg selection
            leverKeys.forEach((key: string) => {
                event_data[key] = addLeverData[key];
            });
            //added all keys from add lever except spend selection
            spendTopForm.forEach((key: string) => {
                event_data[key] = addSpends[key];
            });
            //rest of data
            event_data['spends_data'] = formatAddSpends(spendType, addSpends);
            event_data['dim2_ids'] = idForRestOfComponent.dim2.ids;
            event_data['dim1_data'] = formatDim1_data(addLeverData['SelectedLowerLevel']);
            event_data['tacticDescription'] = `${addLeverData['tacticDescription']}`;
            event_data['offerMethod'] = `${addLeverData['offerMethod']}`;
            if (event_data['offerMethod'] === 'manual') {
                event_data['event_name'] = `${Object.keys(allCheckedAttribute[retailerKey])[0]} ${
                    addLeverData['discount']
                }%_Off ${addLeverData['month']}`;
                event_data['promotionMechanic'] = `${addLeverData['discount']}%_Off`;
                event_data['discount'] = parseInt(`${addLeverData['discount']}`);
            } else if (event_data['offerMethod'] === 'previous') {
                event_data['event_name'] = `${
                    Object.keys(allCheckedAttribute[retailerKey])[0]
                }  ${PromotionMechanicValueData}  ${addLeverData['month']}`;
                event_data['promotionMechanic'] = PromotionMechanicValueData;
                event_data['promptEventName'] = `${addLeverData['promptEventName']}`;
            } else {
                event_data['event_name'] = `${Object.keys(allCheckedAttribute[retailerKey])[0]} ${
                    addLeverData['promotionMechanic']
                } ${addLeverData['month']}`;
                event_data['promotionMechanic'] = `${addLeverData['promotionMechanic']}`;
            }
            console.log(event_data.dim1_data, event_data.spends_data, 'logging ff');
            if (
                Object.keys(event_data.dim1_data).length &&
                (!hideAddSpends ? Object.keys(event_data.spends_data).length : true)
            ) {
                updateEventFunction({
                    variables: {
                        planId: selectedPlan.planId,
                        eventsData: [JSON.stringify({ event_data, event_id: null })],
                        frequency: currentFrequency?.key,
                        operationType: 'add',
                    },
                });
            } else {
                openNotification('Please input all information required.');
            }
        } else {
            let addEventUpdatedData = eventsDataFormat(editRowData);
            if (`${addLeverData['offerMethod']}` === 'manual') {
                delete addEventUpdatedData.promptEventName;
            } else if (`${addLeverData['offerMethod']}` === 'previous') {
                delete addEventUpdatedData.discount;
            } else {
                delete addEventUpdatedData.promptEventName;
                delete addEventUpdatedData.discount;
            }
            let eventsData: any = {
                event_id: editRowData.eventId,
                parent_id: editRowData.parentId,
                event_data: addEventUpdatedData,
            };
            let originalData = eventDataFromOriginalData(editRowData);
            let eventDataFromOriginal: any = {
                event_id: editRowData.eventId,
                event_data: originalData,
            };
            if (_.isEqual(eventDataFromOriginal, eventsData)) {
                openNotification('Please Modify Data.');
            } else {
                updateEventFunction({
                    variables: {
                        planId: selectedPlan.planId,
                        eventsData: [JSON.stringify(eventsData)],
                        frequency: currentFrequency?.key,
                        operationType: 'update',
                    },
                });
            }
        }
    }

    //resetting all state
    function onResetButton() {
        setAddLeverData(() => ({ SelectedLowerLevel: {} }));
        setAddSpends(() => ({ per_qty: {} }));
        setSpendType(() => []);
        setTempRange(() => [null]);
        setStateForCalender(() => ({ step: 1, dateRange: [null] }));
    }
    //modal footer
    let Footer = () => {
        return (
            <div className="w-full flex justify-end gap-2">
                {!editMode && (
                    <Button
                        title={'Reset'}
                        onClick={() => {
                            onResetButton();
                            trackEventMixpanel(PROMO_RECOMMENDATION_ADD_EVENT_RESET_CLICKED);
                        }}
                        style={{ padding: '0px 20px' }}
                    />
                )}
                <Button
                    title={
                        loading ? (
                            <div className="flex justify-center items-center">
                                <Spin indicator={antIcon} />
                            </div>
                        ) : (
                            'Apply'
                        )
                    }
                    onClick={() => {
                        onApplyButton();
                        trackEventMixpanel(
                            editMode
                                ? PROMO_RECOMMENDATION_EDIT_EVENT_APPLY_CLICKED
                                : PROMO_RECOMMENDATION_ADD_EVENT_APPLY_CLICKED,
                        );
                    }}
                    theme={'Solid'}
                    style={{ padding: '0px 20px' }}
                />
            </div>
        );
    };

    return (
        <>
            <CustomModal
                title={editMode ? 'Edit Event' : 'Add Event'}
                open={addEditModal}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={Footer()}
                width={1200}
                centered
                maskClosable={false}
            >
                <div className="flex gap-2 w-full border-collapse -mt-3 mb-2">
                    <AddEditLevers />
                    <AddEditSpends />
                </div>
            </CustomModal>
        </>
    );
};

export default AddEditEventModal;
